/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoAutoCapitalizationNameFilter(): angular.IFilterService {
        const filter = (input: any) => {

            if (!input) {
                return "";
            }

            //remove non-alpha characters
            var name = input.toString()
                //.replace('(^$)|(^([^\-!#\$%&\(\)\*,\./:;\?@\[\\\]_\{\|\}¨ˇ“”€\+<=>§°\d\s¤®™©]| )+$)', '')
                .replace(/[0-9]/g, '');
            return name.charAt(0).toUpperCase() + name.substr(1);
        };
        return filter;
    }

    angular.module("meevo.components.filters")
        .filter("meevoAutoCapitalizationName", meevoAutoCapitalizationNameFilter);
}

module Meevo.Components.Filters {

    export function meevoAutoCapitalizationNameWithHyphenFilter(): angular.IFilterService {
        const filter = (input: any) => {

            if (!input)
                return "";
            var name = input.toString().replace(/^\s+|([\^!#\$%&\(\)\*\./:;\?@\[\\\]_\{\|\}¨ˇ“”€\+<=>§°\d¤®™©])|\-{2,}|^\-/g, '');
            return name.charAt(0).toUpperCase() + name.substr(1);
        };
        return filter;
    }

    angular.module("meevo.components.filters")
        .filter("meevoAutoCapitalizationNameWithHyphenFilter", meevoAutoCapitalizationNameWithHyphenFilter);
}
